import Link from "next/link";
import s from "./CtaButton.module.scss";
import { LinkExternal } from "@/types/common/LinkExternal";
import { Icon } from "@/types/common/ImageData";
import LazyImage from "../LazyImage";
import { urlFor } from "@/sanity/sanity-utils";


interface ButtonProps {
    data: LinkExternal;
    icon: Icon | null;
    border?: boolean;
    borderWhite?: boolean;
}

export default function CtaButton({
    data, icon, border = true, borderWhite = false
}: ButtonProps) {
    
    
    return (
        <div className={`${s.button} ${border ? undefined : s.noBorder} ${borderWhite && s.borderWhite}`}>
            <Link 
                href={data.url} 
                target={data.newWindow ? '_blank' : '_self'} 
            > 
                {icon && 
                    <LazyImage 
                        alt={'icon'}
                        src={icon.imageUrl}
                        blurDataURL=""
                        width={18}
                        height={18}
                        aspectRatio="1/1"
                    />
                }
                <p>{data.title}</p>
                {border ? undefined : 
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                        <path d="M6.5 1C6.5 0.723857 6.27614 0.5 6 0.5L1.5 0.5C1.22386 0.5 1 0.723857 1 1C1 1.27614 1.22386 1.5 1.5 1.5L5.5 1.5L5.5 5.5C5.5 5.77614 5.72386 6 6 6C6.27614 6 6.5 5.77614 6.5 5.5L6.5 1ZM1.35355 6.35355L6.35355 1.35355L5.64645 0.646446L0.646447 5.64645L1.35355 6.35355Z" fill="black"/>
                    </svg>
                }
            </Link>
        </div>
    );
}